import { FixedAssetScheduleRowFormatted } from './fixed-assets-schedule-row-formatted.interface';

export interface FixedAssetScheduleTableDataForPrint {
    t: string;
    rows: FixedAssetScheduleRowFormatted[];
}
